<template>
  <l-default :class="b()">
    <c-container>
      <c-breadcrumb :class="b('breadcrumb')" />
      <h1 :class="b('title')">{{ bundle.bundle.name }}</h1>

      <div :class="b('wrapper')">
        <div :class="b('image-gallery')">
          <c-product-image
            :images="bundle?.bundle.imagePhotos"
            show-as-gallery
          />
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div :class="b('content-wrapper')">
          <div
            v-if="bundle.bundle.textDescription"
            v-html="bundle.bundle.textDescription"
          />
          <div
            v-if="links.length"
            :class="b('links')"
          >
            <e-button
              v-for="(link, index) in links"
              :key="index"
              variant="secondary"
              :href="link.url"
              :title="link.title"
              :target="getLinkTarget(link)"
              rel="noopener noreferrer"
            >
              {{ link.label }}
            </e-button>
          </div>
        </div>
      </div>
      <p :class="b('introduction-label')">
        {{ $t('l-bundle-detail.introductionLabel') }}
      </p>
      <div :class="b('configs')">
        <c-product-bundle
          v-for="(config, index) in bundleConfigs"
          :key="index"
          :class="b('config')"
          :bundle-config="config"
          :show-main-image="false"
        />
      </div>
    </c-container>
  </l-default>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import cBreadcrumb from '@/components/c-breadcrumb.vue';
  import cContainer from '@/components/c-container.vue';
  import cProductBundle from '@/components/c-product-bundle.vue';
  import cProductImage from '@/components/c-product-image.vue';
  import eButton from '@/elements/e-button.vue';
  import lDefault from '@/layouts/l-default.vue';
  import { Link } from '@/types/link';
  import { BundleDetailProductBundle, ProductBundle } from '@/types/product';

  // type Setup = {};

  // type Data = {};

  export default defineComponent({
    name: 'l-bundle-detail',
    components: {
      cProductImage,
      cContainer,
      cProductBundle,
      cBreadcrumb,
      eButton,
      lDefault,
    },

    // components: {},

    props: {
      /**
       * The bundle to display
       */
      bundle: {
        type: Object as PropType<BundleDetailProductBundle>,
        required: true,
      },

      /**
       * The list of Links to show
       */
      links: {
        type: Array as PropType<Link[]>,
        default: () => [],
      },
    },

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      bundleConfigs(): ProductBundle[] {
        const bundleConfigs: ProductBundle[] = [];

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(this.bundle.collections).forEach(([_, collection], index) => {
          const bundleConfig = {
            bundle: {
              ...this.bundle.bundle,
              name: '',
            },
            collections: collection,
          };

          // Set the name only if there is more than 1 bundle
          if (Object.entries(this.bundle.collections).length > 1) {
            bundleConfig.bundle.name = `${this.$t('l-bundle-detail.optionLabel', { index: index + 1 })}`;
          }

          bundleConfigs.push(bundleConfig);
        });

        return bundleConfigs;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      getLinkTarget(link: Link): string {
        return link.target || '_blank';
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .l-bundle-detail {
    padding: 3rem 0;

    &__breadcrumb {
      margin-bottom: 3rem;
    }

    &__title {
      margin-bottom: 1.5rem;
    }

    &__wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 3rem;
      margin-top: 2.5rem;
      margin-bottom: 2rem;

      @include mixins.media(sm) {
        display: grid;
        grid-template-columns: 18rem 1fr;
        margin-top: 3.5rem;
        gap: 2rem;
      }

      @include mixins.media(md) {
        grid-template-columns: 24rem 1fr;
        gap: 5rem;
      }
    }

    &__content-wrapper {
      @include mixins.list-styles;

      display: flex;
      flex-direction: column;
      gap: 1.6rem;

      ul {
        padding-inline-start: 1.5rem;
      }
    }

    &__links {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-end;
      gap: 1rem;
    }

    &__introduction-label {
      font-style: italic;
      margin-bottom: 2rem;
    }

    &__configs {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .c-product-bundle {
      padding-bottom: 0;

      &:not(:first-child) {
        padding-top: 2rem;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
</style>
